import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';

import type { IAppState } from 'shared/common/state';
import type {
  IEtazhiBlackFridayPromoOffersData,
  IEtazhiBlackFridayPromoOffersDataByPlatform,
} from 'shared/types/etazhiBlackFriday';

export const selectEtazhiBlackFridayPromoOffersData = (
  state: IAppState,
): IEtazhiBlackFridayPromoOffersDataByPlatform | null => {
  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  if (!isEnabled) {
    return null;
  }

  const data = state.config.get<IEtazhiBlackFridayPromoOffersData>('proApp.etazhiBlackFridayPromoOffersData');

  return data?.desktop || null;
};
